import { AccordionPanel } from 'app/shared/model/accordion-panel.model';

const eventName = 'Trial Guide Clicked';
export const companyLogoTitleCode = 'settingUpCompanyLogo';

export const TrialStartGuideSteps: AccordionPanel[] = [
  {
    titleCode: 'settingUpFolders',
    iconName: 'folder-closed',
    textContentCode: 'settingUpFoldersContent',
    learnMoreLink: 'https://intercom.help/dashpivot/en/articles/2827406-creating-project-and-team-folders',
    event: {
      name: eventName,
      Context: 'Folders',
    },
  },
  {
    titleCode: companyLogoTitleCode,
    iconName: 'markup',
    textContentCode: 'settingUpCompanyLogoContent',
    event: {
      name: eventName,
      Context: 'Logo',
    },
    actions: {
      openCompanyLogoModal: true,
    },
  },
  {
    titleCode: 'settingUpLists',
    iconName: 'list',
    textContentCode: 'settingUpListsContent',
    learnMoreLink: 'https://intercom.help/dashpivot/en/articles/2563225-lists-overview',
    event: {
      name: eventName,
      Context: 'Lists',
    },
  },
  {
    titleCode: 'usingPhotos',
    iconName: 'photo',
    textContentCode: 'usingPhotosContent',
    learnMoreLink: 'https://intercom.help/dashpivot/en/articles/2563237-photos-overview',
    event: {
      name: eventName,
      Context: 'Photos',
    },
  },
  {
    titleCode: 'settingUpTemplates',
    iconName: 'form-template',
    textContentCode: 'settingUpTemplatesContent',
    learnMoreLink: 'https://intercom.help/dashpivot/en/articles/2563236-templates-overview',
    event: {
      name: eventName,
      Context: 'Templates',
    },
  },
  {
    titleCode: 'usingAnalytics',
    iconName: 'analytics',
    textContentCode: 'usingAnalyticsContent',
    learnMoreLink: 'https://intercom.help/dashpivot/en/articles/2563238-analytics-overview',
    event: {
      name: eventName,
      Context: 'Analytics',
    },
  },
  {
    titleCode: 'addingUsers',
    iconName: 'users',
    textContentCode: 'addingUsersContent',
    learnMoreLink: 'https://intercom.help/dashpivot/en/articles/3199677-adding-users',
    event: {
      name: eventName,
      Context: 'Users',
    },
  },
  {
    titleCode: 'usingTheMobileApp',
    iconName: 'device-mobile',
    textContentCode: 'usingTheMobileAppContent',
    learnMoreLink: 'https://intercom.help/dashpivot/en/articles/2563239-dashpivot-app-overview',
    event: {
      name: eventName,
      Context: 'Mobile',
    },
  },
];
